<template>
  <transition
    name="animate__fadeInRight"
    :enter-active-class="'animate__animated animate__fadeInRight'"
    appear
  >
    <v-row justify="end" align-content="center" class="position-relative">
      <v-col
        cols="9"
        align-self="center"
        class="d-flex justify-end pa-0 position-relative mb-2"
        :class="{ 'desktop-tab-active-class': getActiveTab === 'home' }"
      >
        <v-container
          fluid
          class="backdrop-filter-container d-flex justify-start align-center pl-1 transformX-5px cursor-pointer"
          @click="changeActiveTab('home')"
        >
          <v-btn icon :ripple="false">
            <v-icon :color="getActiveTab === 'home' ? 'success' : 'secondary'"
              >mdi-home</v-icon
            >
          </v-btn>
          <span class="white--text font-size-xs">{{ $translate("home") }}</span>
        </v-container>
      </v-col>
      <v-col
        cols="9"
        align-self="center"
        class="d-flex justify-end pa-0 position-relative mb-2"
        :class="{ 'desktop-tab-active-class': getActiveTab === 'account' }"
      >
        <v-container
          fluid
          class="backdrop-filter-container d-flex justify-start align-center pl-1 transformX-5px cursor-pointer"
          @click="changeActiveTab('account')"
        >
          <v-btn icon :ripple="false">
            <v-icon
              :color="getActiveTab === 'account' ? 'success' : 'secondary'"
              >mdi-account</v-icon
            >
          </v-btn>
          <span class="white--text font-size-xs">
            {{ $translate("myAccount") }}</span
          >
        </v-container>
      </v-col>
      <v-col
        cols="9"
        align-self="center"
        class="d-flex justify-end pa-0 position-relative mb-2"
        :class="{ 'desktop-tab-active-class': getActiveTab === 'shop' }"
      >
        <v-container
          fluid
          class="backdrop-filter-container d-flex justify-start align-center pl-1 transformX-5px cursor-pointer"
          @click="changeActiveTab('shop')"
        >
          <v-btn icon :ripple="false">
            <v-icon :color="getActiveTab === 'shop' ? 'success' : 'secondary'"
              >mdi-cart-outline</v-icon
            >
          </v-btn>
          <span class="white--text font-size-xs">{{ $translate("shop") }}</span>
        </v-container>
      </v-col>

      <transition
        name="animate__fadeInRightOutLeft"
        enter-active-class="animate__animated animate__fadeInRight"
        leave-active-class="animate__animated animate__fadeOutLeft"
        appear
      >
        <v-container
          v-if="getWhatPageIsItIn === 'lobby'"
          align-self="center"
          class="d-flex justify-end pa-0 position-absolute mb-2 my-tables-menu"
          style=""
          :class="{ 'my-tables-expanded': myTablesOpened }"
        >
          <v-container
            fluid
            class="backdrop-filter-container z-index-2000 d-flex justify-start pl-1 transformX-5px px-md-1"
            :class="myTablesOpened ? 'align-start' : 'align-center'"
          >
            <template v-if="!myTablesOpened">
              <button
                class="fill-height fill-width d-flex justify-start align-center vertical-padding-6px"
                @click="myTablesOpened = !myTablesOpened"
              >
                <v-icon class="mr-1" color="accent">mdi-ellipse-outline</v-icon>
                <span class="accent--text font-size-xs font-size-md-xs">
                  {{ $translate("myTables") }}
                </span>
              </button>
            </template>

            <UserPlayingTables
              :showUserPlayingTables="myTablesOpened"
              @toggleShowUserPlayingTables="myTablesOpened = false"
            />
          </v-container>
        </v-container>
      </transition>
      <transition
        name="animate__fadeInRightOutLeft"
        enter-active-class="animate__animated animate__fadeInRight"
        leave-active-class="animate__animated animate__fadeOutLeft"
        appear
      >
        <v-container
          v-if="
            getWhatPageIsItIn === 'lobby' &&
            !lobbyMenuOpened &&
            (isClubAdmin || isClubAgent)
          "
          align-self="center"
          class="d-flex justify-end pa-0 position-absolute mb-2"
          style="bottom: -68%; width: 75%"
        >
          <v-container
            fluid
            class="lobby-menu-container d-flex justify-start align-center pl-1 transformX-5px"
            @click="toggleLobbyMenu()"
          >
            <v-btn icon :ripple="false">
              <v-icon large class="mr-1" color="accent"
                >mdi-dots-horizontal</v-icon
              >
            </v-btn>
            <span class="accent--text font-size-xs">
              {{ $translate("more") }}
              <v-badge
                class="position-absolute ml-2"
                color="red"
                overlap
                dot
                v-if="hasUnreadJoinRequest"
              >
              </v-badge>
            </span>
          </v-container>
        </v-container>
      </transition>
      <transition
        name="animate__fadeInOutRight"
        enter-active-class="animate__animated animate__fadeInRight"
        leave-active-class="animate__animated animate__fadeOutRight"
        appear
      >
        <v-container
          v-if="getWhatPageIsItIn === 'lobby' && lobbyMenuOpened"
          align-self="center"
          class="d-flex justify-end pa-0 position-absolute mb-2 dynamic-footer-menu"
        >
          <v-container
            fluid
            class="lobby-menu-container lobby-menu-container-expanded d-flex justify-start align-center pl-1 transformX-5px"
          >
            <v-row justify="center">
              <v-col cols="10" align-self="center">
                <v-row justify="center" v-if="isClubAdmin && !isClubAgent">
                  <v-col cols="3" align-self="center" class="px-1">
                    <TwoLayerButton
                      :outer-container-class="'outer-button-layer'"
                      :inner-container-class="'inner-button-layer py-1 px-0 font-size-xxs '"
                      :button-text="$translate('union')"
                      :primary-color="'blue'"
                      @button-clicked="emitOpenEvent('openUnionModal')"
                    />
                  </v-col>
                  <v-col cols="3" align-self="center" class="px-1">
                    <TwoLayerButton
                      :outer-container-class="'outer-button-layer'"
                      :inner-container-class="'inner-button-layer py-1 px-0 font-size-xxs '"
                      :button-text="$translate('members')"
                      :primary-color="'blue'"
                      @button-clicked="emitOpenEvent('openMemberManagement')"
                    >
                      <span class="position-relative"
                        >{{ $translate("memberManagement") }}
                        <v-badge
                          class="position-absolute new-member-badge"
                          color="red"
                          overlap
                          dot
                          v-if="hasUnreadJoinRequest"
                        >
                        </v-badge>
                      </span>
                    </TwoLayerButton>
                  </v-col>
                  <v-col cols="3" align-self="center" class="px-1">
                    <TwoLayerButton
                      :outer-container-class="'outer-button-layer'"
                      :inner-container-class="'inner-button-layer py-1 px-0 font-size-xxs '"
                      :button-text="$translate('accounting')"
                      :primary-color="'blue'"
                      @button-clicked="emitOpenEvent('openAccounting')"
                    />
                  </v-col>
                  <v-col cols="3" align-self="center" class="px-1">
                    <TwoLayerButton
                      :outer-container-class="'outer-button-layer'"
                      :inner-container-class="'inner-button-layer py-1 px-0 font-size-xxs '"
                      :button-text="$translate('data')"
                      :primary-color="'blue'"
                      @button-clicked="emitOpenEvent('openClubData')"
                    />
                  </v-col>
                </v-row>
                <v-row justify="start" v-if="isClubAgent">
                  <v-col cols="5" align-self="center" class="px-1">
                    <TwoLayerButton
                      :outer-container-class="'outer-button-layer'"
                      :inner-container-class="'inner-button-layer py-1 px-0 font-size-xxs '"
                      :primary-color="'blue'"
                      @button-clicked="emitOpenEvent('openAgentInfo')"
                    >
                      <span class="position-relative"
                        >{{ $translate("agentInfo") }}
                        <!-- <v-badge
                          class="position-absolute new-member-badge"
                          color="red"
                          overlap
                          dot
                          v-if="hasUnreadJoinRequest"
                        >
                        </v-badge> -->
                      </span>
                    </TwoLayerButton>
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                cols="1"
                align-self="center"
                class="d-flex justify-center font-size-xxs px-1"
              >
                <button
                  class="fill-width d-flex justify-start"
                  @click="toggleLobbyMenu()"
                >
                  <v-icon class="accent--text font-weight-bolder"
                    >mdi-close</v-icon
                  >
                </button>
              </v-col>
            </v-row>
          </v-container>
        </v-container>
      </transition>
    </v-row>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
import TwoLayerButton from "@/components/Helper/TwoLayerButton";
import { eventBus } from "@/services/eventBus";
import UserPlayingTables from "@/components/Modals/UserPlayingTables/UserPlayingTables";

export default {
  name: "DesktopFooter",
  components: { UserPlayingTables, TwoLayerButton },
  props: {
    hasUnreadJoinRequest: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => {
    return {
      activeTab: "home",
      noTransition: false,
      lobbyMenuOpened: false,
      myTablesOpened: false,
      prevRoute: "",
      tabIsChanging: false,
      tabChangingTimeOut: null,
    };
  },
  computed: {
    ...mapGetters([
      "getRouteData",
      "getWhatPageIsItIn",
      "isClubAdmin",
      "isClubAgent",
    ]),
    shouldShowBottomNavigation() {
      return ["home", "lobby", "myAccount", "createTable"].includes(
        this.getWhatPageIsItIn
      );
    },
    getActiveTab() {
      const routerName = this.$route.name;
      let combinedValues = "";
      combinedValues =
        routerName === "Lobby"
          ? routerName
          : `${this.$route.path}-${this.activeTab}`;
      switch (combinedValues) {
        case "/account-account":
          return "account";
        case "/home-home":
          return "home";
        case "/shop-shop":
          return "shop";
        case "Lobby":
          return "home";
        default:
          return;
      }
    },
  },
  methods: {
    toggleLobbyMenu() {
      this.lobbyMenuOpened = !this.lobbyMenuOpened;
    },
    emitOpenEvent(eventName) {
      this.toggleLobbyMenu();
      eventBus.$emit(eventName);
    },
    changeActiveTab(tabToActivate) {
      if (!this.tabIsChanging) {
        this.tabIsChanging = true;
        clearTimeout(this.tabChangingTimeOut);
        this.activeTab = tabToActivate;
        switch (this.activeTab) {
          case "shop":
            this.$router.replace("/shop");
            break;
          case "account":
            this.$router.replace("/account");
            break;
          case "home":
            this.$router.replace("/home");
            break;
          default:
            break;
        }
        this.tabChangingTimeOut = setTimeout(() => {
          this.tabIsChanging = false;
        }, 1000);
      }
    },
  },

  created() {
    this.prevRoute = this.getRouteData.prevRoute.name;
    this.noTransition = ["shop", "account", "home"].includes(this.prevRoute);
    if (this.$route.path.indexOf("/account") > -1) {
      this.activeTab = "account";
    } else if (this.$route.path.indexOf("/home") > -1) {
      this.activeTab = "home";
    } else if (this.$route.path.indexOf("/shop") > -1) {
      this.activeTab = "shop";
    }
  },
  mounted() {
    //  listening to event bus
    eventBus.$on("lobbyMenuClose", () => {
      this.lobbyMenuOpened = false;
    });
  },
  destroyed() {
    clearTimeout(this.tabChangingTimeOut);
  },
  beforeDestroy() {
    eventBus.$off("lobbyMenuClose");
  },
};
</script>

<style scoped>
.new-member-badge {
  top: -30%;
  right: -15%;
  width: 8px;
  height: 8px;
  background-color: #f74906;
  border-radius: 50%;
}
.vertical-padding-6px {
  padding-top: 6px;
  padding-bottom: 6px;
}
.dynamic-footer-menu {
  bottom: -68%;
  width: 220%;
  z-index: 1;
}
.my-tables-menu {
  bottom: -33.5%;
  width: 75%;
  transition: ease-in-out 500ms;
}
/*ipad pro responsive*/
@media only screen and (min-width: 990px) and (max-width: 1200px) and (max-height: 1400px) {
  .dynamic-footer-menu {
    width: 320%;
  }
  .my-tables-expanded {
    width: 200% !important;
    transition: width ease-in-out 500ms;
  }
}

.transformX-5px {
  transform: translateX(5px);
  transition: transform 0s ease-in-out;
}
.my-tables-expanded {
  height: 150%;
  width: 150%;
}
.backdrop-filter-container {
  opacity: 1;
  background-color: var(--input-background-rgba);
  backdrop-filter: blur(8px);
  border-radius: 10px;
  border: 1px solid #39e5bf3c;
  z-index: 1;
}
.lobby-menu-container {
  border-radius: 10px;
  background: linear-gradient(to right, rgba(0, 0, 0, 0.7) 72%, #939393 100%);
  border: 1.5px solid #388ee5;
  z-index: 1;
}
.lobby-menu-container-expanded {
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.7) 90%,
    #706f6f 100%
  ) !important;
}

.desktop-tab-active-class::after {
  content: "";
  position: absolute;
  width: 80%;
  right: 0;
  height: 40%;
  /* Adjust the height for the desired size of the half circle */
  background: linear-gradient(to top, var(--v-success), #535a6a 50%);
  filter: blur(8px);
  bottom: 12%;
  z-index: 0;
}
</style>
